import React, { useState } from 'react';
import './DuplicateLocalModal.css';

export default function DuplicateLocalModal({ isOpen, onClose, local, onDuplicate }) {
  const [nom, setNom] = useState(local?.nom ? `${local.nom} (copie)` : '');
  const [description, setDescription] = useState(local?.description || '');
  const [selectedEquipments, setSelectedEquipments] = useState(
    (local?.equipements || []).map((_, idx) => idx)
  );

  const equipements = local?.equipements || [];

  const handleToggleEquipment = (equipmentIndex) => {
    setSelectedEquipments(prev => 
      prev.includes(equipmentIndex) 
        ? prev.filter(idx => idx !== equipmentIndex)
        : [...prev, equipmentIndex]
    );
  };

  const handleSelectAll = () => {
    setSelectedEquipments(equipements.map((_, idx) => idx));
  };

  const handleDeselectAll = () => {
    setSelectedEquipments([]);
  };

  const handleDuplicate = () => {
    if (!nom.trim()) {
      alert('Veuillez remplir le nom du local');
      return;
    }

    const duplicatedLocal = {
      nom: nom.trim(),
      description: description.trim(),
      equipements: equipements
        .filter((_, idx) => selectedEquipments.includes(idx))
        .map(equipment => ({
          ...equipment,
          obs_ids: [] // NE PAS dupliquer les observations
        }))
    };

    onDuplicate(duplicatedLocal);
  };

  const getEquipmentLabel = (equipment, index) => {
    if (equipment.name) return equipment.name;
    if (equipment.designation) return equipment.designation;
    if (equipment.type) return equipment.type;
    return `Équipement ${index + 1}`;
  };

  if (!isOpen) return null;

  return (
    <div className="duplicate-modal-overlay" onClick={onClose}>
      <div className="duplicate-modal" onClick={(e) => e.stopPropagation()}>
        <div className="duplicate-modal-header">
          <div>
            <h2 className="duplicate-modal-title">📋 Dupliquer le local</h2>
            <p className="duplicate-modal-subtitle">"{local?.nom}"</p>
          </div>
          <button onClick={onClose} className="duplicate-close-button">✕</button>
        </div>

        <div className="duplicate-modal-content">
          <p className="duplicate-description">
            Modifiez les informations du nouveau local et sélectionnez les équipements à dupliquer.
          </p>

          {/* Champs du local */}
          <div className="duplicate-form-group">
            <label className="duplicate-form-label">
              Nom du local <span className="duplicate-required">*</span>
            </label>
            <input
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              className="duplicate-form-input"
              placeholder="Ex: ATELIER MECANIQUE, RESERVE..."
            />
          </div>

          <div className="duplicate-form-group">
            <label className="duplicate-form-label">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="duplicate-form-textarea"
              rows={3}
              placeholder="Description du local..."
            />
          </div>

          {/* Sélection des équipements */}
          <div className="duplicate-equipment-section">
            <div className="duplicate-equipment-header">
              <div className="duplicate-equipment-title">
                <span className="duplicate-form-label">Équipements à dupliquer</span>
                <span className="duplicate-badge">
                  {selectedEquipments.length} / {equipements.length}
                </span>
              </div>
              <div className="duplicate-equipment-actions">
                <button 
                  type="button" 
                  onClick={handleSelectAll}
                  className="duplicate-select-button"
                >
                  Tout
                </button>
                <button 
                  type="button" 
                  onClick={handleDeselectAll}
                  className="duplicate-select-button"
                >
                  Aucun
                </button>
              </div>
            </div>

            {equipements.length === 0 ? (
              <div className="duplicate-empty-equipment">
                <div className="duplicate-empty-icon">⚠️</div>
                <p>Aucun équipement dans ce local</p>
              </div>
            ) : (
              <div className="duplicate-equipment-list">
                {equipements.map((equipment, index) => (
                  <div 
                    key={index} 
                    className={`duplicate-equipment-item ${selectedEquipments.includes(index) ? 'selected' : ''}`}
                    onClick={() => handleToggleEquipment(index)}
                  >
                    <input
                      type="checkbox"
                      checked={selectedEquipments.includes(index)}
                      onChange={() => handleToggleEquipment(index)}
                      className="duplicate-checkbox"
                    />
                    <div className="duplicate-equipment-info">
                      <span className="duplicate-equipment-name">
                        {getEquipmentLabel(equipment, index)}
                      </span>
                      {equipment.type && equipment.type !== equipment.name && (
                        <span className="duplicate-equipment-type">
                          - {equipment.type}
                        </span>
                      )}
                      {equipment.obs_ids?.length > 0 && (
                        <span className="duplicate-equipment-obs">
                          ({equipment.obs_ids.length} obs. non dupliquées)
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="duplicate-info-box">
              <div className="duplicate-info-icon">ℹ️</div>
              <div className="duplicate-info-text">
                <strong>Note importante :</strong> Les équipements seront dupliqués avec leurs données 
                (type, designation, quantité, etc.), mais <strong>sans leurs observations</strong>.
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="duplicate-modal-footer">
          <button onClick={onClose} className="duplicate-cancel-button">
            Annuler
          </button>
          <button 
            onClick={handleDuplicate}
            disabled={!nom.trim() || selectedEquipments.length === 0}
            className="duplicate-save-button"
          >
            📋 Dupliquer le local
          </button>
        </div>
      </div>
    </div>
  );
}